<template>
    <div class="printManagementListClass">
        <div class="searchPart">
            <el-select v-model="serveTypeValue" placeholder="服务行业">
                <el-option
                    label="全部"
                    value="全部">
                </el-option>
                <el-option
                    label="高分子材料"
                    value="高分子材料">
                </el-option>
                <el-option
                    label="金属"
                    value="金属">
                </el-option>
                <el-option
                    label="无机非金属"
                    value="无机非金属">
                </el-option>
            </el-select>
            <el-input v-model="serveNameValue" placeholder="服务名称"></el-input>
            <el-button class="searchBtn">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small">批量删除</el-button>
                    <el-button type="primary" plain size="small">批量发布</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%" @selection-change="handleSelectionChange" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="服务缩略图"
                    header-align="center"
                    align="center"
                    width="250">
                    <template slot-scope="scope">
                        <img :src="scope.row.img" alt="">
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="服务名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    label="服务行业" width="160">
                    <template slot-scope="scope">
                        {{scope.row.serviceType}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    label="价格" width="200">
                    <template slot-scope="scope">
                        {{scope.row.price}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    header-align="center"
                    align="center"
                    width="110">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small">发布</el-button>
                        <el-button type="text" size="small"  @click="toDialog('edit')">编辑</el-button>
                        <el-button type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total,prev, pager, next,jumper"
                :page-size="10"
                :total="1000" class="pagination">
            </el-pagination>
        </div>
        <service-capability-dialog ref="dialogRef"></service-capability-dialog>
    </div>
</template>

<script>
    import serviceCapabilityDialog from './serviceCapabilityDialog'
    export default {
        data(){
            return{
                serveTypeValue: '',
                serveNameValue: '',
                tableData: [
                    {
                    img: require('@/assets/images/serviceImg.png'),
                    serviceType: '工业制造',
                    sort: '1',
                    name: '3DP三维打印3D打印服务',
                    price: '¥2000/千克'
                    },
                    {
                        img: require('@/assets/images/serviceImg.png'),
                        serviceType: '工业制造',
                        sort: '1',
                        name: '3DP三维打印3D打印服务',
                        price: '¥2000/千克'
                    },
                    {
                        img: require('@/assets/images/serviceImg.png'),
                        serviceType: '工业制造',
                        sort: '2',
                        name: '3DP三维打印3D打印服务',
                        price: '¥2000/千克'
                    },
                    {
                        img: require('@/assets/images/serviceImg.png'),
                        serviceType: '工业制造',
                        sort: '3',
                        name: '3DP三维打印3D打印服务',
                        price: '¥2000/千克'
                    },
                    {
                        img: require('@/assets/images/serviceImg.png'),
                        serviceType: '工业制造',
                        sort: '4',
                        name: '3DP三维打印3D打印服务',
                        price: '¥2000/千克'
                    }
                ],
                multipleSelection: []
            }
        },
        components: {
            serviceCapabilityDialog
        },
        methods: {
            // 清除检索条件
            reset(){
                this.serveTypeValue = ''
                this.serveNameValue = ''
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type){
                this.$refs.dialogRef.init(type)
            }
        }
    }
</script>

<style scoped lang="less">
    .printManagementListClass{
        padding: 20px;
        .searchPart {
            display: flex;
            flex-wrap: wrap;
            
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
            
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                
                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            
            /deep/ .el-input__prefix {
                top: -3px;
            }
            
            /deep/ .el-input__suffix {
                top: 2px;
            }
            
            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }
            
            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }
            
            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        .tablePart{
            .tableTool{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                .toolLeft{
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);
                    .num{
                        color: #356FDF;
                    }
                    button{
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;
                        &:hover{
                            background:#157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }
                .toolRight{
                    button{
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;
                        i{
                            padding-right: 5px;
                        }
                        &:hover{
                            background: #61a2f0;
                        }
                    }
                }
            }
            .tableContent{
                min-height: 650px;
                /deep/.el-table__header{
                    tr{
                        th{
                            border-right: none;
                        }
                    }
                    /deep/.el-table__cell{
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }
                /deep/.el-table__body{
                    img{
                        vertical-align: middle;
                        width: 110px;
                        height: 64px;
                    }
                    /deep/.el-table__row{
                        td:first-child{
                            border-right: none;
                            .cell{
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }
            .pagination{
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/serviceCapability.vue